import { ensureLegacyPublic } from '@/legacy/ensure_legacy_public';

await ensureLegacyPublic();
